declare global {
  interface Window {
    __c13Warmup?: boolean
  }
}

/**
 * RESH13-1145: the native app prefetches pages in the background with
 * `?c13Warmup=1` and reloads them without it when the user actually opens
 * them. Set once per document by the inline script in `_document`, before
 * GTM/gtag load, so analytics are never loaded for a prefetch.
 */
export const isAppWarmup = () =>
  typeof window !== 'undefined' && window.__c13Warmup === true
